import { Toast as ReactbootstrapToast } from "react-bootstrap";
import { ToastSeverity } from "./Enum";
import { ToastState } from "./State/ToastState";
import { useEffect, useState } from "react";
import toastService from "./ToastService";

type CombinedProps = ToastState;

const ToastComponent = ({ serverity, message, isOpen }: CombinedProps) => {
  const getClassName = (): string => {
    switch (serverity) {
      case ToastSeverity.Error:
        return "icon icon-danger";
      case ToastSeverity.Success:
        return "icon icon-primary";
      case ToastSeverity.Warning:
        return "icon icon-warning";
      default:
        return "icon icon-info-n";
    }
  }

  const handleClose = () => {}

  return (
    <div id="toastContainer">
    <ReactbootstrapToast
      className="medium"
      bg={serverity}
      show={isOpen}
      delay={3000}
      onClose={handleClose}
      autohide
    >
      <ReactbootstrapToast.Body>
        <span className="d-flex align-items-center">
          <i className={getClassName()} />
        </span>
        <span>{message}</span>

        <span className="btn-close" />
      </ReactbootstrapToast.Body>
    </ReactbootstrapToast>
    </div>
  );
};

export default ToastComponent;
